import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import AppShell from "@/components/layout/AppShell";
import ProtectedRoute from "@/components/layout/ProtectedRoute";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import TicketDetail from "@/pages/TicketDetail";
import Categories from "@/pages/Categories";
import Holidays from "@/pages/Holidays";
import Team from "@/pages/Team";
import Analytics from "@/pages/Analytics";
import SimulatorWhatsApp from "@/pages/SimulatorWhatsApp";
import SimulatorPayment from "@/pages/SimulatorPayment";
import SimulatorTelegram from "@/pages/SimulatorTelegram";

function Shell({ children }) {
    return (
        <ProtectedRoute>
            <AppShell>{children}</AppShell>
        </ProtectedRoute>
    );
}

function AdminShell({ children }) {
    return (
        <ProtectedRoute adminOnly>
            <AppShell>{children}</AppShell>
        </ProtectedRoute>
    );
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/" element={<Shell><Dashboard /></Shell>} />
                        <Route path="/tickets" element={<Shell><Tickets /></Shell>} />
                        <Route path="/tickets/:id" element={<Shell><TicketDetail /></Shell>} />
                        <Route path="/analytics" element={<Shell><Analytics /></Shell>} />
                        <Route path="/categories" element={<AdminShell><Categories /></AdminShell>} />
                        <Route path="/holidays" element={<AdminShell><Holidays /></AdminShell>} />
                        <Route path="/team" element={<AdminShell><Team /></AdminShell>} />
                        <Route path="/simulator/whatsapp" element={<Shell><SimulatorWhatsApp /></Shell>} />
                        <Route path="/simulator/payment" element={<Shell><SimulatorPayment /></Shell>} />
                        <Route path="/simulator/payment/:paymentId" element={<Shell><SimulatorPayment /></Shell>} />
                        <Route path="/simulator/telegram" element={<Shell><SimulatorTelegram /></Shell>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" theme="dark" />
            </AuthProvider>
        </div>
    );
}

export default App;
